import React from 'react';
import { Grid, TextField, makeStyles, Button } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { InfoCard } from '@backstage/core-components';
import { ActivityFilters } from './hooks';

const useStyles = makeStyles(theme => ({
  filterContainer: {
    marginBottom: theme.spacing(2),
  },
  cardContent: {
    padding: theme.spacing(2),
  },
  dateField: {
    minWidth: 150,
  },
  textField: {
    minWidth: 200,
  },
  clearButton: {
    marginTop: theme.spacing(1),
  },
}));

interface ActivityHistoryFiltersProps {
  filters: ActivityFilters;
  onFilterChange: <K extends keyof ActivityFilters>(key: K, value: ActivityFilters[K]) => void;
  onReset: () => void;
}

export const ActivityHistoryFilters = ({
  filters,
  onFilterChange,
  onReset,
}: ActivityHistoryFiltersProps) => {
  const classes = useStyles();

  const formatDateForInput = (date: Date | null): string => {
    if (!date) return '';
    return date.toISOString().split('T')[0];
  };

  const handleDateChange = (key: 'dateStart' | 'dateEnd', value: string) => {
    onFilterChange(key, value ? new Date(value) : null);
  };

  return (
    <InfoCard title="Filters" className={classes.filterContainer}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid item>
          <TextField
            label="Start Date"
            type="date"
            className={classes.dateField}
            InputLabelProps={{ shrink: true }}
            value={formatDateForInput(filters.dateStart)}
            onChange={e => handleDateChange('dateStart', e.target.value)}
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item>
          <TextField
            label="End Date"
            type="date"
            className={classes.dateField}
            InputLabelProps={{ shrink: true }}
            value={formatDateForInput(filters.dateEnd)}
            onChange={e => handleDateChange('dateEnd', e.target.value)}
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item>
          <TextField
            label="User"
            className={classes.textField}
            value={filters.user}
            onChange={e => onFilterChange('user', e.target.value)}
            variant="outlined"
            size="small"
            placeholder="Filter by user..."
          />
        </Grid>
        <Grid item>
          <TextField
            label="System"
            className={classes.textField}
            value={filters.system}
            onChange={e => onFilterChange('system', e.target.value)}
            variant="outlined"
            size="small"
            placeholder="Filter by system..."
          />
        </Grid>
        <Grid item>
          <TextField
            label="Activity"
            className={classes.textField}
            value={filters.feature}
            onChange={e => onFilterChange('feature', e.target.value)}
            variant="outlined"
            size="small"
            placeholder="Filter by activity..."
          />
        </Grid>
        <Grid item>
          <Button
            variant="outlined"
            size="small"
            className={classes.clearButton}
            startIcon={<ClearIcon />}
            onClick={onReset}
          >
            Clear Filters
          </Button>
        </Grid>
      </Grid>
    </InfoCard>
  );
};
